let originDataText = '';
export default {
  bind(el, binding, vnode) {
    // const { value } = binding;
    // setTimeout(_=>{
    //   originDataText = el.innerHTML;
    // },300)
  },
  update(el, binding, vnode) {
    const { value } = binding;
    if(!value.keyword) {
      return
    };
    let { prop, row, keyword } = value;
    let $content = el.querySelector('.el-table__body-wrapper tbody');
    let $trList = $content.querySelectorAll('tr');
    let $tag = $trList[row].querySelectorAll('td')[prop.substring(3)]

    let values = $tag.innerHTML.split(keyword);
    $tag.innerHTML = values.join('<span style="background:red;">' + keyword + '</span>')
  }
}
